import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Location } from '@angular/common';
import { routesBackLanding } from '../resources/routes-back-landing.constant';
import { routesData } from '../resources/routes.constant';
import { DialogOptionsService } from '../services/dialog-options.service';
import { MoreInfoService } from '../services/more-info.service';

@Injectable({
  providedIn: 'root'
})
export class RouteProtectionGuard implements CanActivate {
  backEvent = false;
  onlyOnceBack: boolean = false;
  timeOut: any;

  constructor(
    public router: Router,
    public location: Location,
    private dialogOptionsService: DialogOptionsService,
    private moreInfoService: MoreInfoService
  ) {
    this.location.subscribe(() => {
      if (
        !this.onlyOnceBack &&
        routesBackLanding.some((url) => url === this.router.url)
      ) {
        this.backEvent = true;
        this.openBackRedirectionDialog();
      }
    });
  }

  openBackRedirectionDialog() {
    this.moreInfoService.setMoreInfo({
      ...this.moreInfoService.moreInfoData,
      isShowedBackRedirection: true
    });
    this.dialogOptionsService.openDialogWithCustomOptions(
      'backRedirection',
      'dialog-back-redirection',
      {
        width: '420px',
        maxWidth: '420px'
      }
    );

    let dialogRef = this.dialogOptionsService.getCurrentDialogRef();

    dialogRef.beforeClosed().subscribe((redirect) => {
      if (redirect === undefined) {
        this.backEvent = true;
        dialogRef = this.dialogOptionsService.getCurrentDialogRef()!;
        dialogRef.close();
        this.redirect();
      } else if (redirect) {
        this.redirect();
      } else {
        dialogRef.close();
        this.backEvent = false;
        this.moreInfoService.setMoreInfo({
          ...this.moreInfoService.moreInfoData,
          isShowedBackRedirection: false
        });
        this.eraseBrowserHistory();
      }
    });
  }

  canActivate(): boolean {
    const urlTree = this.router.parseUrl(
      this.router.getCurrentNavigation().finalUrl.toString()
    );
    urlTree.queryParams = {};
    const url = urlTree.toString();
    if (
      this.backEvent ||
      this.moreInfoService.getMoreInfo().isShowedBackRedirection
    ) {
      return false;
    }

    if (
      (this.router.navigated && url !== routesData.HOME.redirectPath) ||
      url === routesData.HOME.redirectPath
    ) {
      this.eraseBrowserHistory();
      return true;
    } else {
      this.router.navigate([routesData.HOME.redirectPath]);
      return false;
    }
  }

  eraseBrowserHistory(): void {
    this.onlyOnceBack = true;
    history.pushState(null, '', window.location.href);
    this.timeOut = setTimeout(() => {
      this.onlyOnceBack = false;
    }, 100);
  }

  redirect(): void {
    window.location.href = routesData.APP_BASE_HREF.path;
  }
}
